import React from 'react';
import MenuContainer from './ThreeTierMenu/MenuContainer';

const MainMenu = ({ categories }) => (
  <nav>{categories && <MenuContainer queryData={categories} />}</nav>
);

export default MainMenu;
